import { PartyPopperIcon } from './PartyPopperIcon';

/**
 * author: Google
 * id AED614C4-13E2-4009-9D9F-950258DB5124
 * name party-popper
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/party-popper.svg
 * tags
 * - Holiday 
 */
export const CelebrationIcon = PartyPopperIcon;
export default CelebrationIcon